import { Component, Input, OnInit } from '@angular/core';
import { AppService } from '../../../app.service';

@Component({
  selector: 'app-trustbox',
  templateUrl: './trustbox.component.html'
})
export class TrustboxComponent implements OnInit {
  constructor(
    private app: AppService,
  ) {}
  trustboxId = `trustbox-${Date.now()}`
  ngOnInit() {
    this.app.windowObject('Trustpilot', this.trustboxId, (trustpilot) => {
      const elRef = document.getElementById(this.trustboxId);
      for (const key in this.attributes) {
        elRef.dataset[key] = this.attributes[key];
      }
      try {
        trustpilot.loadFromElement(elRef);
      } catch (e) {
        throw new Error(`Could not initialize Trustpilot widget, ${e}`);
      }
    });
  }
  @Input() attributes: Record<string, string>;
  @Input() utmSource: string;
  @Input() utmMedium: string;
}